
import desktopRoutes from '@/router/desktop_routes'

/**
 * 路由配置
 */
let routes = [
  /**
   * 首页
   */
  {
    path: '/home',
    name: 'home',
    label: '',
    component: () => import('@/views/system/home'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: 'AA班级助手-班主任发通知神器'
    }
  },
  /**
   * 新官网首页
   */
  {
    path: '/',
    name: 'new_home',
    label: '',
    component: () => import('@/views/system/new_home'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: 'AA班级助手'
    }
  },
  /**
   * 创建/加入班级
   */
  {
    path: '/class/create',
    name: 'create_class',
    label: '',
    component: () => import('@/views/class/create'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建班级'
    }
  },
  {
    path: '/class/invite/:id',
    name: 'invite_class',
    label: '',
    component: () => import('@/views/class/invite_class'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建班级'
    }
  },
  {
    path: '/class/invite/:id/accept',
    name: 'invite_class_accept',
    label: '',
    component: () => import('@/views/class/invite_class_accept'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建班级申请'
    }
  },
  {
    path: '/class/:class_id/transform_class',
    name: 'transform_class',
    label: '',
    component: () => import('@/views/class/transform_class'),
    children: [],
    meta: {
      is_admin: true,
      title: '转让班级'
    }
  },
  {
    path: '/class/:class_id/transform_class/:id/accept',
    name: 'transform_class_accept',
    label: '',
    component: () => import('@/views/class/transform_class'),
    children: [],
    meta: {
      is_admin: false,
      title: '转让班级'
    }
  },
  {
    path: '/class/transform_class/:id/subscribe',
    name: 'transform_class_subscribe',
    label: '',
    component: () => import('@/views/class/join_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '转让班级'
    }
  },
  {
    path: '/class/:class_id/create_success',
    name: 'create_class_success',
    label: '',
    component: () => import('@/views/class/create_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级创建成功'
    }
  },
  {
    path: '/class/:class_id/create_succeed',
    name: 'create_class_success_new',
    label: '',
    component: () => import('@/views/class/create_succeed'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级创建成功'
    }
  },
  {
    path: '/class/:class_id/join/:role?',
    name: 'join_class',
    label: '',
    component: () => import('@/views/class/join'),
    children: [],
    meta: {
      is_admin: false,
      title: '加入班级-选择角色'
    }
  },
  {
    path: '/class/:class_id/join/:role',
    name: 'join_class_final',
    label: '',
    component: () => import('@/views/class/join'),
    children: [],
    meta: {
      is_admin: false,
      title: '加入班级-完善信息'
    }
  },
  {
    path: '/class/:class_id/add_child',
    name: 'add_child',
    label: '',
    component: () => import('@/views/class/join'),
    children: [],
    meta: {
      is_admin: false,
      title: '添加孩子'
    }
  },
  // 新生分班查询demo
  {
    path: '/class/new_grade_join',
    name: 'new_grade_join_demo',
    label: '',
    component: () => import('@/views/class/new_grade_join'),
    children: [],
    meta: {
      is_admin: false,
      title: '新生分班查询'
    }
  },
  // 新生分班查询demo
  {
    path: '/class/:class_id/new_grade_join_final',
    name: 'new_grade_join_demo_final',
    label: '',
    component: () => import('@/views/class/new_grade_join'),
    children: [],
    meta: {
      is_admin: false,
      title: '新生分班查询'
    }
  },
  // 新生分班查询
  {
    path: '/school/:school_id/new_grade_join',
    name: 'new_grade_join',
    label: '',
    component: () => import('@/views/class/new_grade_join'),
    children: [],
    meta: {
      is_admin: false,
      title: '新生分班查询'
    }
  },
  // 新生分班查询
  {
    path: '/school/:school_id/new_grade_join_final/:class_id',
    name: 'new_grade_join_final',
    label: '',
    component: () => import('@/views/class/new_grade_join'),
    children: [],
    meta: {
      is_admin: false,
      title: '新生分班查询'
    }
  },
  {
    path: '/join_class/:join_id/wait',
    name: 'join_class_wait',
    label: '',
    component: () => import('@/views/class/join_class_wait'),
    meta: {
      is_admin: false,
      title: '等待审核'
    }
  },
  // 是否通过审核页面
  {
    path: '/join_class/:join_id/verify',
    name: 'join_class_verify',
    label: '',
    component: () => import('@/views/class/join_class_verify'),
    meta: {
      is_admin: false,
      title: '等待审核'
    }
  },
  {
    path: '/join_class/:join_id/result',
    name: 'join_class_approved',
    label: '',
    component: () => import('@/views/class/join_class_approved'),
    meta: {
      is_admin: false,
      title: '审核结果'
    }
  },

  /**
   * 加入成功页面
   */
  {
    path: '/class/:class_id/join_success',
    name: 'join_class_success',
    label: '',
    component: () => import('@/views/class/join_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '进入班级'
    }
  },
  {
    path: '/punch_in/copy_invite/:id/accept_success',
    name: 'accept_copy_success',
    label: '',
    component: () => import('@/views/class/join_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '进入班级'
    }
  },
  {
    path: '/class/invite/:id/subscribe',
    name: 'invite_class_subscribe',
    label: '',
    component: () => import('@/views/class/join_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建班级'
    }
  },
  {
    path: '/teacher/settings',
    name: 'teacher_settings',
    label: '',
    component: () => import('@/views/teacher/settings.vue'),
    children: [],
    meta: {
      is_admin: true,
      title: '教师设置',
      feedback: true
    }
  },
  {
    path: '/notification/create',
    name: 'create_notification',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'notification',
      title: '发布通知',
      feedback: true
    }
  },
  {
    path: '/examination/create',
    name: 'create_examination',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'examination',
      title: '发布考试',
      feedback: true
    }
  },
  {
    path: '/notification/create/:minimal',
    name: 'minimal_create_notification',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'notification',
      title: '发布通知',
      feedback: true
    }
  },
  {
    path: '/homework/create',
    name: 'create_homework',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'homework',
      title: '发布作业',
      feedback: true
    }
  },
  {
    path: '/homework/create/:minimal',
    name: 'minimal_create_homework',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'homework',
      title: '发布作业',
      feedback: true
    }
  },
  {
    path: '/punch_in/create',
    name: 'create_punch_in',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'punch_in',
      title: '发布打卡',
      feedback: true
    }
  },
  // 发布快捷打卡页面
  // 非班主任/管理员也可以进入
  {
    path: '/punch_in/create/:minimal',
    name: 'minimal_create_punch_in',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'punch_in',
      title: '发布打卡',
      feedback: true
    }
  },
  // {
  //   path: '/notification/create',
  //   name: 'create_notification',
  //   label: '',
  //   component: () => import('@/views/notification/new_create'),
  //   children: [],
  //   meta: {
  //     is_admin: true,
  //     notification_type: 'notification',
  //     title: '发布通知',
  //     feedback: true
  //   }
  // },
  // {
  //   path: '/homework/create',
  //   name: 'create_homework',
  //   label: '',
  //   component: () => import('@/views/notification/new_create'),
  //   children: [],
  //   meta: {
  //     is_admin: true,
  //     notification_type: 'homework',
  //     title: '发布作业',
  //     feedback: true
  //   }
  // },
  {
    path: '/form/create',
    name: 'create_form',
    label: '',
    component: () => import('@/views/form/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'form',
      title: '发布信息采集',
    }
  },
  {
    path: '/payment/create',
    name: 'create_payment',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'payment',
      title: '班级收款',
      feedback: true
    }
  },
  {
    path: '/payment/create/:minimal',
    name: 'minimal_create_payment',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'payment',
      title: '发布班级收款',
    }
  },
  {
    path: '/payment/:id/edit',
    name: 'edit_payment',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'payment',
      title: '班级收款',
      feedback: true
    }
  },
  {
    path: '/form/create/:minimal',
    name: 'minimal_create_form',
    label: '',
    component: () => import('@/views/form/create'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'form',
      title: '发布信息采集',
      feedback: true
    }
  },
  {
    path: '/form/:id/edit',
    name: 'edit_form',
    label: '',
    component: () => import('@/views/form/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'form',
      title: '编辑信息采集',
      feedback: true
    }
  },
  {
    path: '/punch_in/:id/edit',
    name: 'edit_punch_in',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'punch_in',
      title: '编辑打卡',
      feedback: true
    }
  },
  {
    path: '/notification/:id/edit',
    name: 'edit_notification',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'notification',
      title: '编辑通知',
      feedback: true
    }
  },
  {
    path: '/homework/:id/edit',
    name: 'edit_homework',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'homework',
      title: '编辑作业',
      feedback: true
    }
  },
  // {
  //   path: '/notification/:id/edit',
  //   name: 'edit_notification',
  //   label: '',
  //   component: () => import('@/views/notification/new_create'),
  //   children: [],
  //   meta: {
  //     is_admin: true,
  //     notification_type: 'notification',
  //     title: '编辑通知',
  //     feedback: true
  //   }
  // },
  {
    path: '/examination/:id/edit',
    name: 'edit_examination',
    label: '',
    component: () => import('@/views/notification/create'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'examination',
      title: '编辑考试',
      feedback: true
    }
  },
  // {
  //   path: '/homework/:id/edit',
  //   name: 'edit_homework',
  //   label: '',
  //   component: () => import('@/views/notification/new_create'),
  //   children: [],
  //   meta: {
  //     is_admin: true,
  //     notification_type: 'homework',
  //     title: '编辑作业',
  //     feedback: true
  //   }
  // },
  {
    path: '/promote/daily_post_report',
    name: 'daily_post_report',
    label: '',
    component: () => import('@/views/promote/daily_post_report'),
    children: [],
    meta: {
      is_admin: true,
      title: '每日红花建议',
    }
  },
  {
    path: '/promote/flower_report/:id',
    name: 'flower_report',
    label: '',
    component: () => import('@/views/promote/flower_report'),
    children: [],
    meta: {
      is_admin: false,
      title: '每日红花建议',
    }
  },
  {
    path: '/promote/turn_flower_report',
    name: 'turn_flower_report',
    label: '',
    component: () => import('@/views/promote/turn_flower_report'),
    children: [],
    meta: {
      is_admin: true,
      title: '每日红花建议',
    }
  },
  {
    path: '/notification/:id',
    name: 'notification_info',
    label: '',
    component: () => import('@/views/notification/common_info'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'notification',
      title: '通知概览',
    }
  },
  {
    path: '/punch_in/:id',
    name: 'punch_in_detail',
    label: '',
    component: () => import('@/views/notification/punch_in_detail'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'punch_in',
      title: '打卡详情',
    }
  },
  {
    path: '/punch_in/:id/posts',
    name: 'punch_in_info',
    label: '',
    component: () => import('@/views/notification/common_info'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'punch_in',
      title: '打卡概览',
    }
  },
  {
    path: '/homework/:id',
    name: 'homework_info',
    label: '',
    component: () => import('@/views/notification/common_info'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'homework',
      title: '作业概览',
    }
  },
  {
    path: '/form/:id',
    name: 'form_info',
    label: '',
    component: () => import('@/views/notification/common_info'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'form',
      title: '信息采集概览',
    }
  },
  {
    path: '/payment/:id',
    name: 'payment_info',
    label: '',
    component: () => import('@/views/notification/common_info'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'payment',
      title: '班级收款概览',
    }
  },
  /**
   * 相比于【通知概览】页面，
   * 【班级通知详情】页面包含此班级的讨论，作业提交等更加详细的信息
   */
  {
    path: '/class/:class_id/notification/:id',
    name: 'class_notification_detail',
    label: '',
    component: () => import('@/views/notification/detail'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'notification',
      title: '班级通知详情',
    }
  },
  {
    path: '/class/:class_id/homework/:id',
    name: 'class_homework_detail',
    label: '',
    component: () => import('@/views/notification/detail'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'homework',
      title: '班级作业详情',
    }
  },
  {
    path: '/class/:class_id/punch_in/:id',
    name: 'class_punch_in_detail',
    label: '',
    component: () => import('@/views/notification/detail'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'punch_in',
      title: '班级打卡详情',
    }
  },
  {
    path: '/class/:class_id/payment/:id',
    name: 'class_payment_detail',
    label: '',
    component: () => import('@/views/notification/payment_detail'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'payment',
      title: '班级收款详情',
    }
  },
  {
    path: '/assign_to_other_class/:type/:post_id',
    name: 'assign_to_other_class',
    label: '',
    component: () => import('@/views/class/assign_to_other_class'),
    children: [],
    meta: {
      is_admin: false,
    }
  },
  {
    path: '/assign_to_other_class/:type/:id/success',
    name: 'assign_to_other_class_success',
    label: '',
    component: () => import('@/views/class/assign_to_other_class_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建成功',
    }
  },
  {
    path: '/assign_to_other_class/:type/:id/confirm',
    name: 'assign_to_other_class_confirm',
    label: '',
    component: () => import('@/views/class/assign_to_other_class_confirm'),
    children: [],
    meta: {
      is_admin: false,
      title: '老师想要安排...',
    }
  },
  {
    path: '/assign_to_other_class/:type/:id/confirm_success',
    name: 'assign_to_other_class_confirm_success',
    label: '',
    component: () => import('@/views/class/assign_to_other_class_confirm_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建成功',
    }
  },
  {
    path: '/assign_to_other_class/:type/:id/subscribe_qrcode',
    name: 'assign_to_other_class_qrcode',
    label: '',
    component: () => import('@/views/class/join_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建成功',
    }
  },
  {
    path: '/assign_to_other_accept/:type/:id/subscribe_qrcode',
    name: 'assign_to_other_accept_qrcode',
    label: '',
    component: () => import('@/views/class/join_success'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建成功',
    }
  },
  {
    path: '/class/:class_id/form/:id',
    name: 'class_form_detail',
    label: '',
    component: () => import('@/views/form/form_detail'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'form',
      title: '信息采集',
    }
  },
  {
    path: '/class/:class_id/:type/:id/stats',
    name: 'class_post_stats',
    label: '',
    component: () => import('@/views/form/form_preview'),
    children: [],
    meta: {
      is_admin: true,
      title: '查看统计结果',
    }
  },
  {
    path: '/class/:class_id/form/:id/preview',
    name: 'class_form_preview',
    label: '',
    component: () => import('@/views/form/form_preview'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'form',
      title: '信息采集预览',
    }
  },
  {
    path: '/class/:class_id/cycle_form/:id',
    name: 'class_cycle_form_list',
    label: '',
    component: () => import('@/views/form/cycle_form_list'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'form',
      title: '采集结果',
    }
  },
  {
    path: '/class/:class_id/cycle_form/:id/download',
    name: 'form_cycle_download',
    label: '',
    component: () => import('@/views/form/form_batch_download'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'form',
      title: '下载文件',
    }
  },
  {
    path: '/form/:id/classes_download',
    name: 'form_classes_download',
    label: '',
    component: () => import('@/views/form/form_batch_download'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'form',
      title: '下载文件',
    }
  },
  {
    path: '/class/:class_id/punch_in/:id/download_list',
    name: 'class_punchin_download_list',
    label: '',
    component: () => import('@/views/form/cycle_form_list'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'punch_in',
      title: '打卡统计',
    }
  },
  {
    path: '/class/:class_id/punch_in/:id/batch_download',
    name: 'punchin_batch_download',
    label: '',
    component: () => import('@/views/form/form_batch_download'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'punch_in',
      title: '下载文件',
    }
  },
  {
    path: '/class/:class_id/payment/:id/preview',
    name: 'class_payment_preview',
    label: '',
    component: () => import('@/views/form/form_preview'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'payment',
      title: '班级缴费',
    }
  },
  {
    path: '/payment_request/:id',
    name: 'payment_request',
    label: '',
    component: () => import('@/views/notification/payment_request'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级收款',
    }
  },
  {
    path: '/notification/:id/share_template/:tid',
    name: 'notification_share_template',
    label: '',
    component: () => import('@/views/form/share_template'),
    children: [],
    meta: {
      is_admin: false,
      title: '通知模板分享',
      notification_type: 'notification',
    }
  },
  {
    path: '/homework/:id/share_template/:tid',
    name: 'homework_share_template',
    label: '',
    component: () => import('@/views/form/share_template'),
    children: [],
    meta: {
      is_admin: false,
      title: '作业模板分享',
      notification_type: 'homework',
    }
  },
  {
    path: '/punch_in/:id/share_template/:tid',
    name: 'punch_in_share_template',
    label: '',
    component: () => import('@/views/form/share_template'),
    children: [],
    meta: {
      is_admin: false,
      title: '打卡模板分享',
      notification_type: 'punch_in',
    }
  },
  {
    path: '/form/:id/share_template/:tid',
    name: 'form_share_template',
    label: '',
    component: () => import('@/views/form/share_template'),
    children: [],
    meta: {
      is_admin: false,
      title: '采集模板分享',
      notification_type: 'form',
    }
  },
  {
    path: '/examination/:id/share_template/:tid',
    name: 'examination_share_template',
    label: '',
    component: () => import('@/views/form/share_template'),
    children: [],
    meta: {
      is_admin: false,
      title: '考试模板分享',
      notification_type: 'examination',
    }
  },
  {
    path: '/payment/:id/share_template/:tid',
    name: 'payment_share_template',
    label: '',
    component: () => import('@/views/form/share_template'),
    children: [],
    meta: {
      is_admin: false,
      title: '收款模板分享',
      notification_type: 'payment',
    }
  },
  {
    path: '/class/:class_id/notification/:id/graded',
    name: 'class_notification_graded',
    label: '',
    component: () => import('@/views/notification/graded'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'notification',
      title: '极速通知批改',
    }
  },
  {
    path: '/class/:class_id/homework/:id/graded',
    name: 'class_homework_graded',
    label: '',
    component: () => import('@/views/notification/graded'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'homework',
      title: '极速作业批改',
    }
  },
  {
    path: '/class/:class_id/punch_in/:id/graded',
    name: 'class_punch_in_graded',
    label: '',
    component: () => import('@/views/notification/graded'),
    children: [],
    meta: {
      is_admin: true,
      notification_type: 'punch_in',
      title: '极速打卡批改',
    }
  },
  {
    path: '/punch_in/:id/create_success',
    name: 'punch_in_create_success',
    label: '',
    component: () => import('@/views/notification/punch_in_detail'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'punch_in',
      title: '打卡创建成功'
    }
  },
  {
    path: '/class/:class_id/punch_in/:id/stats',
    name: 'class_punch_in_statistics',
    label: '',
    component: () => import('@/views/notification/statistics'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'punch_in',
      title: '打卡统计',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/punch_in/:id/report',
    name: 'class_punch_in_report',
    label: '',
    component: () => import('@/views/notification/punch_in_report'),
    children: [],
    meta: {
      is_admin: false,
      no_auth: true,
      notification_type: 'punch_in',
      title: '打卡报告'
    }
  },
  {
    path: '/class/:class_id/punch_in/:id/punchin_share_report/:user_id',
    name: 'punchin_share_report',
    label: '',
    component: () => import('@/views/promote/punchin_share_report'),
    children: [],
    meta: {
      is_admin: false,
      no_auth: true,
      title: '打卡报告'
    }
  },
  {
    path: '/punch_in/:id/copy',
    name: 'copy_punch_in',
    label: '',
    component: () => import('@/views/notification/copy_punch_in'),
    children: [],
    meta: {
      is_admin: true,
      title: '安排其他班打卡'
    }
  },
  {
    path: '/punch_in/:id/copy_invite/:copy_id',
    name: 'copy_punch_in_invite',
    label: '',
    component: () => import('@/views/notification/copy_punch_in_invite'),
    children: [],
    meta: {
      is_admin: true,
      title: '创建成功'
    }
  },
  {
    path: '/punch_in/copy_invite/:id/accept',
    name: 'accept_punch_in_invite',
    label: '',
    component: () => import('@/views/notification/accept_punch_in_invite'),
    children: [],
    meta: {
      is_admin: false,
      title: '确认安排打卡'
    }
  },
  {
    path: '/post/stop_rush_report/:id',
    name: 'stop_rush_report',
    label: '',
    component: () => import('@/views/notification/stop_rush_report'),
    children: [],
    meta: {
      is_admin: true,
      title: '不再提醒'
    }
  },
  {
    path: '/class/:class_id/post_answer/:post_id/:notification_type',
    name: 'post_answer',
    label: '',
    component: () => import('@/views/notification/post_answer'),
    children: [],
    meta: {
      is_admin: false,
      title: ''
    }
  },
  {
    path: '/class/:class_id/submit_success/:post_id/:notification_type',
    name: 'submit_success',
    label: '',
    component: () => import('@/views/notification/post_answer'),
    children: [],
    meta: {
      is_admin: false,
      title: ''
    }
  },
  /**
   * 家长看所有科目成绩页
   */
  {
    path: '/student/:student_id/score_list/:exam_id',
    name: 'score_list',
    label: '',
    component: () => import('@/views/exam/score_list'),
    children: [],
    meta: {
      title: '考试成绩',
    }
  },
  /**
   * 家长看单科成绩详情页
   */
  {
    path: '/student/:student_id/score_view/:exam_id/:score_id?',
    name: 'score_view',
    label: '',
    component: () => import('@/views/exam/score_view'),
    children: [],
    meta: {
      title: '考试成绩',
    }
  },
  /**
   * 老师看成绩详情页
   */
  {
    path: '/class/:class_id/exam_scores/:exam_id',
    name: 'exam_scores',
    label: '',
    component: () => import('@/views/exam/exam_scores'),
    children: [],
    meta: {
      title: '考试成绩',
      feedback: true
    }
  },
  /**
   * 老师看成绩详情页预览
   */
  {
    path: '/class/:class_id/exam_scores/:exam_id/preview',
    name: 'exam_scores_preview',
    label: '',
    component: () => import('@/views/exam/exam_scores'),
    children: [],
    meta: {
      is_admin: true,
      title: '考试成绩预览',
    }
  },
  /**
   * 家长认领成绩页
   */
  {
    path: '/class/:class_id/connect_name/:exam_id',
    name: 'connect_name',
    label: '',
    component: () => import('@/views/exam/connect_name'),
    children: [],
    meta: {
      title: '成绩发放通知',
      feedback: true
    }
  },
  {
    path: '/examination/:id',
    name: 'examination_info',
    label: '',
    component: () => import('@/views/notification/common_info'),
    children: [],
    meta: {
      is_admin: false,
      notification_type: 'examination',
      title: '在线考试概览',
    }
  },
  /**
   * 在线考试详情页
   */
  {
    path: '/class/:class_id/examination/:id',
    name: 'class_examination_detail',
    label: '',
    component: () => import('@/views/examination/examination_detail'),
    children: [],
    meta: {
      title: '在线考试',
      notification_type: 'examination',
    }
  },
  /**
   * 在线考试结果分析
   */
  {
    path: '/class/:class_id/examination/:id/analyse',
    name: 'class_examination_analyse',
    label: '',
    component: () => import('@/views/examination/class_examination_analyse'),
    children: [],
    meta: {
      is_admin: true,
      title: '在线考试',
    }
  },
  /**
   * 在线考试提交成功，展示学生分析
   */
  {
    path: '/class/:class_id/student/:student_id/examination/:id/analyse',
    name: 'student_examination_analyse',
    label: '',
    component: () => import('@/views/examination/student_examination_analyse'),
    children: [],
    meta: {
      title: '提交成功',
    }
  },
  {
    path: '/class/:class_id/settings',
    name: 'class_settings',
    label: '',
    component: () => import('@/views/class/settings'),
    children: [],
    meta: {
      is_admin: true,
      title: '班级设置',
      feedback: true
    }
  },
  /**
   * 成员管理页面
   */
  {
    path: '/class/:class_id/members/:target',
    name: 'class_members',
    label: '',
    component: () => import('@/views/class/members'),
    children: [],
    meta: {
      is_admin: true,
      title: '成员管理',
      feedback: true
    }
  },
  /**
   * 学生红花点评页面
   */
  {
    path: '/class/:class_id/evaluation',
    name: 'class_evaluation',
    label: '',
    component: () => import('@/views/class/evaluation'),
    children: [],
    meta: {
      is_admin: true,
      title: 'AA红花',
    }
  },
  /**
   * 颁发奖状页面
   */
  {
    path: '/class/post_certificate',
    name: 'class_post_certificate',
    label: '',
    component: () => import('@/views/class/class_post_certificate'),
    children: [],
    meta: {
      is_admin: false,
      title: '颁发奖状',
    }
  },
  /**
   * 奖状详情页面
   */
  {
    path: '/class/:class_id/class_certificate/:cert_id',
    name: 'class_certificate_detail',
    label: '',
    component: () => import('@/views/class/class_certificate_detail'),
    children: [],
    meta: {
      is_admin: false,
      title: '奖状颁发',
    }
  },
  /**
   * 外部奖状详情页面
   */
  {
    path: '/promote/certificate/:cert_id',
    name: 'instant_certificate_detail',
    label: '',
    component: () => import('@/views/class/class_certificate_detail'),
    children: [],
    meta: {
      is_admin: false,
      title: '奖状颁发',
    }
  },
  /**
   * 外部奖状下载关注页面
   */
  {
    path: '/promote/certificate_download/:cert_key',
    name: 'certificate_download',
    label: '',
    component: () => import('@/views/promote/certificate_download'),
    children: [],
    meta: {
      is_admin: false,
      title: '奖状下载',
    }
  },
  /**
   * 解散班级页面
   */
  {
    path: '/class/:class_id/dissolve_class',
    name: 'dissolve_class',
    label: '',
    component: () => import('@/views/class/dissolve_class'),
    children: [],
    meta: {
      is_admin: true,
      title: '解散班级'
    }
  },
  /**
   * 加入的班级为已解散页面
   */
  {
    path: '/class/join_dissolve',
    name: 'join_dissolve',
    label: '',
    component: () => import('@/views/class/join_dissolve'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级已解散'
    }
  },
  /**
   * 认领班主任
   */
  {
    path: '/class/:class_id/claim_master',
    name: 'claim_master',
    label: '',
    component: () => import('@/views/class/claim_master'),
    children: [],
    meta: {
      is_admin: true,
      title: '认领班主任'
    }
  },
  /**
   * 教师退出班级页面
   */
  {
    path: '/class/:class_id/quit_class/:role',
    name: 'quit_class',
    label: '',
    component: () => import('@/views/class/quit_class'),
    children: [],
    meta: {
      is_admin: false,
      title: '退出班级'
    }
  },
  /**
   * 家长退出班级页面
   */
  {
    path: '/class/:class_id/quit_parent/:student_id',
    name: 'quit_parent',
    label: '',
    component: () => import('@/views/class/quit_parent'),
    children: [],
    meta: {
      is_admin: false,
      title: '退出班级'
    }
  },
  /**
   * 班级花名册介绍页
   */
  {
    path: '/class/:class_id/infomation',
    name: 'infomation',
    label: '',
    component: () => import('@/views/class/infomation'),
    children: [],
    meta: {
      is_admin: true,
      title: '班级花名册',
    }
  },
  /**
   * 班级花名册收集页
   */
  {
    path: '/class/:class_id/infomation/:type',
    name: 'infomation_detail',
    label: '',
    component: () => import('@/views/class/infomation_detail'),
    children: [],
    meta: {
      is_admin: false,
      title: '填写表单',
    }
  },
  {
    path: '/class/:class_id/infomation/preview/:type?',
    name: 'class_infomation_preview',
    label: '',
    component: () => import('@/views/form/form_preview'),
    children: [],
    meta: {
      is_admin: true,
      title: '班级花名册',
    }
  },
  // 班级水滴/红花排行榜页面
  {
    path: '/class/:class_id/drops_rank',
    name: 'class_drops_rank',
    label: '',
    component: () => import('@/views/class/drops_rank'),
    children: [],
    meta: {
      is_admin: false,
      title: '红花排行榜'
    }
  },
  // 榜单统计
  {
    path: '/class/:class_id/drops_rank_list',
    name: 'class_drops_rank_list',
    label: '',
    component: () => import('@/views/class/drops_rank_list'),
    children: [],
    meta: {
      is_admin: false,
      title: '历史榜单'
    }
  },
  // 历史榜单
  {
    path: '/class/:class_id/drops_rank_history/:id',
    name: 'class_drops_rank_history',
    label: '',
    component: () => import('@/views/class/drops_rank_history'),
    children: [],
    meta: {
      is_admin: false,
      title: '红花排行榜',
      no_auth: true,
    }
  },
  // 科目周榜详情
  {
    path: '/class/:class_id/subject_drops_rank/:id',
    name: 'subject_drops_rank',
    label: '',
    component: () => import('@/views/class/subject_drops_rank'),
    children: [],
    meta: {
      is_admin: false,
      title: '红花排行榜',
      no_auth: true,
    }
  },
  /**
   * 通知列表页面
   * 1.个人系统消息列表
   * https://lanhuapp.com/web/#/item/board/detail?pid=02717866-f1d4-4c60-8024-161e75fcf53d&project_id=02717866-f1d4-4c60-8024-161e75fcf53d&image_id=8e887db7-c623-4d44-9e1d-e55267a42ccb
   *
   *
   * 2.班级通知列表
   * https://lanhuapp.com/web/#/item/board/detail?pid=02717866-f1d4-4c60-8024-161e75fcf53d&project_id=02717866-f1d4-4c60-8024-161e75fcf53d&image_id=702a88e6-2b76-41a5-9297-53ed31cebd99
   *
   * 3.班级作业列表
   * https://lanhuapp.com/web/#/item/board/detail?pid=02717866-f1d4-4c60-8024-161e75fcf53d&project_id=02717866-f1d4-4c60-8024-161e75fcf53d&image_id=0ed4ec60-cdec-48f8-9109-8864b4e862ce
   *
   * 4.老师历史发送通知列表(发布记录)
   * https://lanhuapp.com/web/#/item/board/detail?pid=02717866-f1d4-4c60-8024-161e75fcf53d&project_id=02717866-f1d4-4c60-8024-161e75fcf53d&image_id=36a3eafc-5388-43b0-a520-55306f3854bb
   */
  {
    path: '/notifications',
    name: 'system_notifications',
    label: '',
    component: () => import('@/views/notification/list'),
    children: [],
    meta: {
      is_admin: true,
      title: '个人消息列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/posts',
    name: 'class_post_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'post',
      is_admin: true,
      title: '班级发布记录',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/notifications',
    name: 'class_notification_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'notification',
      is_admin: true,
      title: '班级通知列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/posts',
    name: 'class_student_post_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'post',
      is_admin: false,
      title: '班级动态',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/notifications',
    name: 'class_student_notification_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'notification',
      is_admin: false,
      title: '学生通知列表',
      feedback: true
    }
  },
  // 其他类型通知,如type为homework,则访问: /class/:id/notifications/homework
  {
    path: '/class/:class_id/homeworks',
    name: 'class_homework_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'homework',
      is_admin: true,
      title: '班级作业列表',
      feedback: true
    }
  },
  // 多科作业统计 设计稿地址： https://lanhuapp.com/web/#/item/project/board?pid=5cd6aacc-5263-434d-8428-ed4ff7e286e7&see=all
  {
    path: '/homeworks_summary/:id',
    name: 'homeworks_summary',
    label: '',
    component: () => import('@/views/class/homeworks_summary'),
    children: [],
    meta: {
      is_admin: true,
      title: '作业统计',
      feedback: true
    }
  },
  // 多科作业统计优化 设计稿地址： https://lanhuapp.com/web/#/item/project/board?type=share_mark&pid=a20fbb20-07cf-4124-9c28-c7382559e88f&activeSectionId=&teamId=7b6af50e-c31d-42ab-9f99-e68ddccfe4cc&param=8c23a2a5-5eae-4bb0-8bd6-bfcbdacf0892
  {
    path: '/class/:class_id/homeworks_summary/list',
    name: 'homeworks_summary_list',
    label: '',
    component: () => import('@/views/class/homeworks_summary_list'),
    children: [],
    meta: {
      is_admin: true,
      title: '历史记录',
      feedback: true
    }
  },
  {
    path: '/homeworks_summary/custom',
    name: 'homeworks_summary_custom',
    label: '',
    component: () => import('@/views/class/homeworks_summary_custom'),
    children: [],
    meta: {
      is_admin: true,
      title: '作业统计',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/homeworks',
    name: 'class_student_homework_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'homework',
      is_admin: false,
      title: '学生作业列表',
      feedback: true
    }
  },
  // 老师/班主任历史通知(包含作业)列表
  {
    path: '/teacher/notifications',
    name: 'my_post_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'history',
      is_admin: true,
      title: '发布记录',
      feedback: true
    }
  },
  // 老师/班主任定时发布列表
  {
    path: '/teacher/unsend_list',
    name: 'unsend_list',
    label: '',
    component: () => import('@/views/class/unsend_list'),
    children: [],
    meta: {
      notification_type: 'unsend',
      is_admin: true,
      title: '定时发布列表',
      feedback: true
    }
  },
  // 老师/班主任定时发布列表
  {
    path: '/post/trashbin/lists',
    name: 'trashbin_list',
    label: '',
    component: () => import('@/views/class/trashbin_list'),
    children: [],
    meta: {
      notification_type: 'trashbin',
      is_admin: false,
      title: '回收站',
    }
  },
  // 打卡列表
  {
    path: '/class/:class_id/punch_in',
    name: 'class_punch_in_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'punch_in',
      is_admin: true,
      title: '班级打卡列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/punch_in',
    name: 'class_student_punch_in_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'punch_in',
      is_admin: false,
      title: '学生打卡列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/exam_list',
    name: 'class_exam_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'exam',
      is_admin: true,
      title: '班级成绩列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/exam_list',
    name: 'class_student_exam_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'exam',
      is_admin: false,
      title: '学生成绩列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/form_list',
    name: 'class_form_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'form',
      is_admin: true,
      title: '班级采集列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/form_list',
    name: 'class_student_form_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'form',
      is_admin: false,
      title: '学生采集列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/payment_list',
    name: 'class_payment_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'payment',
      is_admin: true,
      title: '班级收款列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/payment_list',
    name: 'class_student_payment_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'payment',
      is_admin: false,
      title: '学生收款列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/examination_list',
    name: 'class_examination_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'examination',
      is_admin: true,
      title: '班级考试列表',
      feedback: true
    }
  },
  {
    path: '/class/:class_id/student/:student_id/examination_list',
    name: 'class_student_examination_list',
    label: '',
    component: () => import('@/views/class/notifications'),
    children: [],
    meta: {
      notification_type: 'examination',
      is_admin: false,
      title: '学生考试列表',
      feedback: true
    }
  },
  /**
   * 我的孩子页面
   */
  {
    path: '/children',
    name: 'my_children',
    label: '',
    component: () => import('@/views/parent/children'),
    children: [],
    meta: {
      is_admin: false,
      title: '孩子主页',
      feedback: true
    }
  },
  /**
   * 单个孩子页面
   */
  {
    path: '/children/:student_id?',
    name: 'my_child',
    label: '',
    component: () => import('@/views/parent/child'),
    children: [],
    meta: {
      is_admin: false,
      title: '孩子主页',
      feedback: true
    }
  },
  {
    path: '/class/admin/home/:class_id?',
    name: 'admin_home',
    label: '',
    component: () => import('@/views/class/home'),
    children: [],
    meta: {
      is_admin: true,
      title: '首页'
    }
  },
  /**
   * 分享邀请页面
   */
  {
    path: '/class/:class_id/invite',
    name: 'invite',
    label: '',
    component: () => import('@/views/class/invite'),
    children: [],
    meta: {
      is_admin: false,
      title: '邀请加入班级'
    }
  },
  // 邀请班内成员
  {
    path: '/class/:class_id/invite/:target/:accept?',
    name: 'invite_class_user',
    label: '',
    component: () => import('@/views/class/user_invite'),
    children: [],
    meta: {
      is_admin: false,
      title: ''
    }
  },
  // 邀请学生家长
  {
    path: '/student/:student_id/invite/:target/:accept?',
    name: 'invite_student_parents',
    label: '',
    component: () => import('@/views/class/user_invite'),
    children: [],
    meta: {
      is_admin: false,
      title: ''
    }
  },
  /**
   * 班级机器人群内设置
   */
  {
    path: '/class/feature_settings/:feature',
    name: 'feature_settings',
    label: '',
    component: () => import('@/views/class/feature_settings'),
    children: [],
    meta: {
      is_admin: true,
      title: '提醒设置'
    }
  },
  // 邀请好友(如班主任)
  {
    path: '/invite/:target/:accept?',
    name: 'invite_user',
    label: '',
    component: () => import('@/views/class/user_invite'),
    children: [],
    meta: {
      is_admin: false,
      title: ''
    }
  },
  // 邀请好友(如班主任)
  {
    path: '/invite_remind/class/:class_id/:target/:user_id',
    name: 'invite_reward_remind',
    label: '',
    component: () => import('@/views/class/invite_reward_remind'),
    children: [],
    meta: {
      is_admin: false,
      title: ''
    }
  },
  // 跳转到邀请家长
  {
    path: '/class/invite_redirect/:role?',
    name: 'invite_redirect',
    label: '',
    component: () => import('@/views/class/invite_redirect'),
    children: [],
    meta: {
      is_admin: true,
      title: ''
    }
  },
  /**
   * 修改学号
   */
  {
    path: '/class/:class_id/modify_sn',
    name: 'modify_sn',
    label: '',
    component: () => import('@/views/class/modify_sn'),
    children: [],
    meta: {
      is_admin: true,
      title: '修改学号'
    }
  },
  /**
   * 微信授权后，跳转授权页面
   * 通过code, state注册/授权用户
   */
  {
    path: '/system/auth',
    name: 'wechat_auth',
    label: '',
    component: () => import('@/views/system/auth'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '微信授权'
    }
  },
  // 登出
  {
    path: '/system/logout',
    name: 'user_logout',
    label: '',
    component: () => import('@/views/system/logout'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '退出登录'
    }
  },
  // PC端扫码登录的手机页面
  {
    path: '/system/scan_qrcode',
    name: 'scan_qrcode',
    label: '',
    component: () => import('@/views/system/scan_qrcode'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '扫码登录'
    }
  },

  /**
   * 家委会可用通知余额页面(需分页)
   *
   * 设计稿：https://lanhuapp.com/web/#/item/board/detail?pid=02717866-f1d4-4c60-8024-161e75fcf53d&project_id=02717866-f1d4-4c60-8024-161e75fcf53d&image_id=288160d7-1ae1-4cd8-a59e-13df1216fa63
   */
  {
    path: '/committee/balance',
    name: 'committee_balance',
    label: '',
    component: () => import('@/views/committee/balance'),
    children: [],
    meta: {
      is_admin: true,
      title: '可用通知余额'
    }
  },
  /**
   * 红花中心页面
   *
   * 设计稿：https://lanhuapp.com/web/#/item/project/board?pid=3f387adb-8fc8-4064-8acc-1f052149c82c
   */
  {
    path: '/teacher/flowers_center',
    name: 'flowers_center',
    label: '',
    component: () => import('@/views/teacher/flowers_center'),
    children: [],
    meta: {
      is_admin: true,
      title: '红花中心',
      feedback: true
    }
  },
  /**
   * 班主任积分页面(需分页)
   *
   * 设计稿：https://lanhuapp.com/web/#/item/board/detail?pid=02717866-f1d4-4c60-8024-161e75fcf53d&project_id=02717866-f1d4-4c60-8024-161e75fcf53d&image_id=46c7d904-1070-4e90-9f19-2f5751fc7132
   */
  {
    path: '/teacher/credits',
    name: 'teacher_credits',
    label: '',
    component: () => import('@/views/teacher/credits'),
    children: [],
    meta: {
      is_admin: true,
      title: '我的积分',
      feedback: true
    }
  },
  {
    path: '/student/:student_id/flowers',
    name: 'student_flowers',
    label: '',
    component: () => import('@/views/student/flowers'),
    children: [],
    meta: {
      title: '红花记录'
    }
  },
  {
    path: '/teacher/flowers',
    name: 'teacher_flowers',
    label: '',
    component: () => import('@/views/student/flowers'),
    children: [],
    meta: {
      title: '红花记录'
    }
  },
  /**
   * 班主任积分兑换页面
   *
   */
  {
    path: '/teacher/transfer_credits',
    name: 'teacher_transfer_credits',
    label: '',
    component: () => import('@/views/teacher/transfer'),
    children: [],
    meta: {
      is_admin: true,
      title: '积分提现'
    }
  },
  /**
   * 引导新用户创建打卡页面
   *
   */
  {
    path: '/guide/create_class',
    name: 'guide_create_class',
    label: '',
    component: () => import('@/views/guide/create_class'),
    children: [],
    meta: {
      is_admin: false,
      title: '认领小助手'
    }
  },
  /**
   * 模拟对话发布post
   *
   */
  {
    path: '/guide/ai_chat',
    name: 'ai_chat',
    label: '',
    component: () => import('@/views/guide/ai_chat'),
    children: [],
    meta: {
      is_admin: true,
      title: '发布通知'
    }
  },
  /**
   * 引导到电脑发布成绩
   *
   */
  {
    path: '/guide/publish_score',
    name: 'guide_publish_score',
    label: '',
    component: () => import('@/views/guide/publish_score'),
    children: [],
    meta: {
      is_admin: false,
      title: '发布成绩'
    }
  },
  /**
   * 引导到电脑创建/修改试卷
   *
   */
  {
    path: '/guide/publish_examination',
    name: 'guide_publish_examination',
    label: '',
    component: () => import('@/views/guide/publish_examination'),
    children: [],
    meta: {
      is_admin: false,
      title: '创建/修改试卷'
    }
  },
  /**
   * 一键创建打卡
   *
   */
  {
    path: '/guide/one_click_publish',
    name: 'one_click_publish',
    label: '',
    component: () => import('@/views/guide/one_click_publish'),
    children: [],
    meta: {
      is_admin: true,
      title: '创建打卡'
    }
  },
  /**
   * 引导新用户创建打卡页面
   *
   */
  {
    path: '/guide/create_punch_in',
    name: 'guide_create_punch_in',
    label: '',
    component: () => import('@/views/guide/create_punch_in'),
    children: [],
    meta: {
      is_admin: true,
      title: '创建打卡'
    }
  },
  /**
   * 发放成绩后邀请家长加入班级
   *
   */
  {
    path: '/guide/exam_publish/:id',
    name: 'exam_publish',
    label: '',
    component: () => import('@/views/guide/exam_publish'),
    children: [],
    meta: {
      is_admin: false,
      title: '成绩发放通知'
    }
  },
  /**
   * 第一次发放成绩后邀请家长加入班级
   *
   */
  {
    path: '/guide/exam_publish_invite/:id',
    name: 'exam_publish_invite',
    label: '',
    component: () => import('@/views/guide/exam_publish_invite'),
    children: [],
    meta: {
      is_admin: false,
      title: '家长认领成绩'
    }
  },
  /**
   * 错误页面
   *
   * 404
   */
  {
    path: '/system/notfound',
    name: 'notfound',
    label: '',
    component: () => import('@/views/system/notfound'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '页面未找到'
    }
  },
  /**
   * 错误页面
   * 500
   */
  {
    path: '/system/server_exception',
    name: 'server_exception',
    label: '',
    component: () => import('@/views/system/server_exception'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '系统维护'
    }
  },
  /**
   * 错误页面
   * 500
   */
  {
    path: '/system/server_pause',
    name: 'server_pause',
    label: '',
    component: () => import('@/views/system/server_pause'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '服务器繁忙'
    }
  },
  /**
   * 引导用户加机器人页面
   */
  {
    path: '/system/wechat_guide',
    name: 'wechat_guide',
    label: '',
    component: () => import('@/views/system/wechat_guide'),
    children: [],
    meta: {
      is_admin: false,
      title: '认领小助手'
    }
  },
  {
    path: '/system/replace_bot',
    name: 'replace_bot',
    label: '',
    component: () => import('@/views/system/replace_bot'),
    children: [],
    meta: {
      is_admin: false,
      title: '通知/作业代发服务'
    }
  },
  {
    path: '/system/stop_join_notification',
    name: 'stop_join_notification',
    label: '',
    component: () => import('@/views/system/stop_join_notification'),
    children: [],
    meta: {
      is_admin: false,
      title: '不再提醒'
    }
  },
  /**
   * 无小孩页面
   *
   */
  {
    path: '/system/no_child',
    name: 'no_child',
    label: '',
    component: () => import('@/views/system/no_child'),
    children: [],
    meta: {
      is_admin: false,
      title: '我的孩子'
    }
  },
  /**
   * 无权限页面
   */
  {
    path: '/system/permission_denied',
    name: 'admin_permission_denied',
    label: '',
    component: () => import('@/views/system/permission_denied'),
    children: [],
    meta: {
      is_admin: false,
      title: '没有权限'
    }
  },
  /**
   * 管理员绑定机器人页面
   */
  {
    path: '/system/bind_bot',
    name: 'admin_bind_bot',
    label: '',
    component: () => import('@/views/system/bind_bot'),
    children: [],
    meta: {
      is_admin: false,
      title: '开通代发通知服务'
    }
  },
  /**
   * 管理员绑定机器人并跳转到打卡模板中心
   */
  {
    path: '/system/bind_bot_redirect',
    name: 'admin_bind_bot_redirect',
    label: '',
    component: () => import('@/views/system/bind_bot_redirect'),
    children: [],
    meta: {
      is_admin: false,
      title: '正在打开'
    }
  },
  /**
   * 激活客服消息页面
   */
  {
    path: '/system/comment_message_redirect',
    name: 'comment_message_redirect',
    label: '',
    component: () => import('@/views/system/message_redirect'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级通知'
    }
  },
  // 客服中心跳转页面
  {
    path: '/system/customer_redirect',
    name: 'customer_redirect',
    label: '',
    component: () => import('@/views/system/customer_redirect'),
    children: [],
    meta: {
      is_admin: false,
      title: 'AA服务中心',
    }
  },
  // 客服中心关注二维码页面
  {
    path: '/system/subscribe_platform_customer',
    name: 'subscribe_platform_customer',
    label: '',
    component: () => import('@/views/class/join_success'),
    children: [],
    meta: {
      is_admin: false,
      title: 'AA服务中心',
    }
  },
  // 获取用户信息页面
  {
    path: '/system/toggle_prerelease',
    name: 'toggle_prerelease',
    label: '',
    component: () => import('@/views/system/toggle_prerelease'),
    children: [],
    meta: {
      is_admin: false,
      title: '切换新/旧版本'
    }
  },
  /**
   * 确认置顶公众号跳转页面
   */
  {
    path: '/system/wechat_top_up_redirect',
    name: 'user_wechat_top_up_redirect',
    label: '',
    component: () => import('@/views/system/wechat_top_up_redirect'),
    children: [],
    meta: {
      is_admin: false,
      title: '正在确认'
    }
  },
  /**
   * 引导置顶公众号页面
   */
  {
    path: '/promote/wechat_top_up_guide/banner_a',
    name: 'user_wechat_top_up_guide_banner_a',
    label: '',
    component: () => import('@/views/promote/wechat_top_up_guide'),
    children: [],
    meta: {
      is_admin: false,
      title: '置顶公众号'
    }
  },
  /**
   * 引导置顶公众号页面
   */
  {
    path: '/promote/wechat_top_up_guide/banner_b',
    name: 'user_wechat_top_up_guide_banner_b',
    label: '',
    component: () => import('@/views/promote/wechat_top_up_guide'),
    children: [],
    meta: {
      is_admin: false,
      title: '置顶公众号'
    }
  },
  /**
   * 引导置顶公众号页面
   */
  {
    path: '/promote/wechat_top_up_guide/other',
    name: 'user_wechat_top_up_guide_other',
    label: '',
    component: () => import('@/views/promote/wechat_top_up_guide'),
    children: [],
    meta: {
      is_admin: false,
      title: '置顶公众号'
    }
  },
  /**
   * 引导置顶公众号页面
   */
  {
    path: '/promote/wechat_top_up_guide/global_message',
    name: 'user_wechat_top_up_guide_global_message',
    label: '',
    component: () => import('@/views/promote/wechat_top_up_guide'),
    children: [],
    meta: {
      is_admin: false,
      title: '置顶公众号'
    }
  },
  /**
   * 翻盘抽奖介绍页面
   */
  {
    path: '/promote/flip_card_lottery',
    name: 'flip_card_lottery',
    label: '',
    component: () => import('@/views/promote/flip_card_lottery'),
    children: [],
    meta: {
      is_admin: false,
      no_auth: true,
      title: '班主任大抽奖'
    }
  },
  /**
   * 翻盘抽奖页面
   */
  {
    path: '/promote/flip_card_lottery/draw',
    name: 'flip_card_lottery_draw',
    label: '',
    component: () => import('@/views/promote/flip_card_lottery_draw'),
    children: [],
    meta: {
      is_admin: false,
      title: '班主任大抽奖'
    }
  },
  /**
   * 翻盘抽奖结果页面
   */
  {
    path: '/promote/flip_card_lottery/result',
    name: 'flip_card_lottery_result',
    label: '',
    component: () => import('@/views/promote/flip_card_lottery_result'),
    children: [],
    meta: {
      is_admin: false,
      title: '班主任大抽奖'
    }
  },
  /**
   * 红包抽奖页面2021.02.21
   */
  {
    path: '/promote/redpack_lottery/draw',
    name: 'redpack_lottery_draw',
    label: '',
    component: () => import('@/views/promote/redpack_lottery_draw'),
    children: [],
    meta: {
      is_admin: false,
      title: 'AA抽奖'
    }
  },
  /**
   * 班级使用报告入口页面
   */
  {
    path: '/promote/class/usage_report_entry',
    name: 'usage_report_entry',
    label: '',
    component: () => import('@/views/promote/usage_report_entry'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级使用报告'
    }
  },
  /**
   * 班级使用报告页面
   */
  {
    path: '/promote/class/:class_id/usage_report',
    name: 'usage_report',
    label: '',
    component: () => import('@/views/promote/usage_report'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '班级使用报告'
    }
  },
  {
    path: '/promote/punch_in_templates',
    name: 'punch_in_templates',
    label: '',
    component: () => import('@/views/promote/punch_in_templates'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级打卡特邀活动'
    }
  },
  {
    path: '/promote/summer_punch_in_templates',
    name: 'summer_punch_in_templates',
    label: '',
    component: () => import('@/views/promote/summer_punch_in_templates'),
    children: [],
    meta: {
      is_admin: false,
      title: '班级打卡特邀活动'
    }
  },
  // 促进活跃的任务
  {
    path: '/promote/active_tasks',
    name: 'active_tasks',
    label: '',
    component: () => import('@/views/promote/active_tasks'),
    children: [],
    meta: {
      is_admin: true,
      title: '21天积分活动'
    }
  },
  // 促进活跃的任务
  {
    path: '/promote/usage_example',
    name: 'usage_example',
    label: '',
    component: () => import('@/views/promote/usage_example'),
    children: [],
    meta: {
      is_admin: false,
      title: '她们这样使用AA班级助手'
    }
  },
  // 积分任务专区
  {
    path: '/promote/task_list',
    name: 'task_list',
    label: '',
    component: () => import('@/views/promote/task_list'),
    children: [],
    meta: {
      is_admin: true,
      title: '积分任务专区'
    }
  },
  // 积分任务文章页面
  {
    path: '/promote/article/:id',
    name: 'article',
    label: '',
    component: () => import('@/views/promote/article'),
    children: [],
    meta: {
      is_admin: false,
      no_auth: true,
      title: '班主任！暑假不规划，开学头都大！督促学生最佳暑假计划'
    }
  },
  // 获取用户信息页面
  {
    path: '/promote/user_info',
    name: 'user_info',
    label: '',
    component: () => import('@/views/promote/user_info'),
    children: [],
    meta: {
      is_admin: false,
      title: '您的用户信息'
    }
  },
  {
    path: '/promote/ai_invite',
    name: 'ai_invite',
    label: '',
    component: () => import('@/views/promote/ai_invite'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '人工智能打卡助手'
    }
  },
  {
    path: '/promote/master_invite',
    name: 'master_invite',
    label: '',
    component: () => import('@/views/promote/master_invite'),
    children: [],
    meta: {
      is_admin: true,
      title: '邀好友一起用AA'
    }
  },
  {
    path: '/promote/master_invite/accept',
    name: 'master_invite_accept',
    label: '',
    component: () => import('@/views/promote/master_invite_accept'),
    children: [],
    meta: {
      is_admin: false,
      title: '邀请你使用班级助手...'
    }
  },
  {
    path: '/promote/verify_vip',
    name: 'verify_vip',
    label: '',
    component: () => import('@/views/promote/verify_vip'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '激活VIP'
    }
  },
  {
    path: '/promote/pandaalbum',
    name: 'pandaalbum_found',
    label: '',
    component: () => import('@/views/promote/pandaalbum'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '智能发现'
    }
  },
  {
    path: '/promote/pandaalbum/ios_widget',
    name: 'pandaalbum_ios_widget',
    label: '',
    component: () => import('@/views/promote/pandaalbum_ios_widget'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: ''
    }
  },
  {
    path: '/promote/comment_article',
    name: 'comment_article',
    label: '',
    component: () => import('@/views/promote/comment_article'),
    children: [],
    meta: {
      is_admin: false,
      title: '分享后下载'
    }
  },
  {
    path: '/promote/accept_comment_article',
    name: 'accept_comment_article',
    label: '',
    component: () => import('@/views/promote/comment_article'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '期末评语'
    }
  },
  {
    path: '/promote/comment_invite',
    name: 'comment_invite',
    label: '',
    component: () => import('@/views/promote/comment_invite'),
    children: [],
    meta: {
      is_admin: false,
      title: '免费获取永久版'
    }
  },
  {
    path: '/promote/master_redirect',
    name: 'master_redirect',
    label: '',
    component: () => import('@/views/promote/master_redirect'),
    children: [],
    meta: {
      is_admin: false,
      title: '正在打开...'
    }
  },
  {
    path: '/promote/parent_redirect',
    name: 'parent_redirect',
    label: '',
    component: () => import('@/views/promote/parent_redirect'),
    children: [],
    meta: {
      is_admin: false,
      title: '正在打开...'
    }
  },
  {
    path: '/promote/get_flower',
    name: 'get_flower',
    label: '',
    component: () => import('@/views/promote/get_flower'),
    children: [],
    meta: {
      is_admin: true,
      title: '领取红花'
    }
  },
  {
    path: '/promote/get_drop',
    name: 'get_drop',
    label: '',
    component: () => import('@/views/promote/get_drop'),
    children: [],
    meta: {
      is_admin: false,
      title: '领取水滴'
    }
  },
  {
    path: '/promote/teacher_help_group',
    name: 'teacher_help_group',
    label: '',
    component: () => import('@/views/promote/teacher_help_group'),
    children: [],
    meta: {
      is_admin: true,
      title: '教师帮助群'
    }
  },
  /**
   * AA家长平台入口
   */
  {
    path: '/promote/aa_platform_entry',
    name: 'aa_platform_entry',
    label: '',
    component: () => import('@/views/promote/aa_platform_entry'),
    children: [],
    meta: {
      is_admin: false,
      title: 'AA家长平台'
    }
  },
  /**
   * 教师成长营入口
   */
  {
    path: '/promote/teacher_growth',
    name: 'teacher_growth',
    label: '',
    component: () => import('@/views/promote/teacher_growth'),
    children: [],
    meta: {
      is_admin: false,
      title: '教师成长营'
    }
  },
  /**
   * 熊猫选娃入口
   */
   {
    path: '/panda_album',
    redirect: {
      name: 'panda_album_subscribe'
    }
  },
  {
    path: '/panda_album/*',
    redirect: {
      name: 'panda_album_subscribe'
    }
  },
  {
    path: '/panda_album/subscribe',
    name: 'panda_album_subscribe',
    label: '',
    component: () => import('@/views/promote/panda_album_subscribe'),
    children: [],
    meta: {
      is_admin: false,
      no_auth: true,
      title: '熊猫选娃'
    }
  },
  {
    path: '/company/IyqrrmbftUK9xueSE1qR0w',
    name: '',
    label: '',
    component: () => import('@/views/company/_bp'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: 'AA班级助手-项目说明'
    }
  },
  {
    path: '/company/IyqrrmbftUK9xueSE1qR0w/20200408',
    name: '',
    label: '',
    component: () => import('@/views/company/_bp20200408'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: 'AA班级-BP-微信轻读版'
    }
  },
  {
    path: '/issues',
    name: 'issues',
    label: '',
    component: () => import('@/views/promote/issues'),
    children: [],
    meta: {
      is_admin: false,
      title: '教师互助社区',
      keepAlive: true
    }
  },
  // 教师互助社区详情
  {
    path: '/issue/:id/detail',
    name: 'issue_detail',
    label: '',
    component: () => import('@/views/promote/issue_detail'),
    children: [],
    meta: {
      is_admin: false,
      title: '教师互助社区'
    }
  },
  // 新建教师互助社区
  {
    path: '/issue/new',
    name: 'issue_new',
    label: '',
    component: () => import('@/views/promote/issue_edit'),
    children: [],
    meta: {
      is_admin: false,
      title: '教师互助社区'
    }
  },
  // 修改教师互助社区
  {
    path: '/issue/:id/edit',
    name: 'issue_edit',
    label: '',
    component: () => import('@/views/promote/issue_edit'),
    children: [],
    meta: {
      is_admin: false,
      title: '教师互助社区'
    }
  },
  // 新建教师互助社区留言
  // {
  //   path: '/issue/:id/comment/new',
  //   name: 'issue_comment_edit',
  //   label: '',
  //   component: () => import('@/views/promote/issue_comment_edit'),
  //   children: [],
  //   meta: {
  //     is_admin: false,
  //     title: '教师互助社区'
  //   }
  // },
  // 红花文章
  {
    path: '/article_task/:id',
    name: 'article_task',
    label: '',
    component: () => import('@/views/teacher/article_task'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '分享文章'
    }
  },
  // 授权他人下载
  {
    path: '/promote/share_files',
    name: 'share_files',
    label: '',
    component: () => import('@/views/promote/share_files'),
    children: [],
    meta: {
      no_auth: true,
      is_admin: false,
      title: '授权下载'
    }
  },
  // 所有未找到页面都跳转到notfound
  {
    path: '*',
    redirect: {
      name: 'notfound'
    }
  },
]

routes = routes.concat(desktopRoutes)

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js